import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AttractionsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"attractions"}/>
}
